import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader} from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C205DeviceImportProps {
  execDeviceImport: (deviceId: string, signed_url: string) => Promise<Result>
  loading: loadStatus
}
// C205 デバイスインポートAPI呼出
export const useC205DeviceImport = (): C205DeviceImportProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execDeviceImport = async (deviceId: string, signed_url: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      // const fileData = await base64Encode(importFile);
      // const body = { file_data: fileData };
      const body = { url: signed_url }

      const response = await axios.post(
        buildDeviceUrl(deviceId, '/import'),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceImport, loading }
}
